<template>
    <div class="row g-4 mt-1" v-show="chartValue.length">
        <template v-for="(item) in chartValue" :key="item.name">
            <div class="col-md-6" v-if="item.consumption > 0">
                <EntitlementUsageCard :item="item" :type="type" />
            </div>
        </template>
    </div>
</template>

<script>
import EntitlementUsageCard from './EntitlementUsageCard.vue';

export default {
    name: 'EntitlementUsageCharts',
    components: { EntitlementUsageCard },
    props: {
        chartValue: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: ""
        }
    }
};
</script>
